<script setup lang="ts">
import {FREQUENTATION_LEVELS} from "@/agenda/lib/frequentation";

/**
 * The four attendance levels and their colours, as every frequentation
 * display reads them. Anything to add after the swatches — a link, a note —
 * goes in the default slot.
 */
defineProps<{
    /** Wording before the swatches. */
    label?: string;
}>();
</script>

<template>
  <div class="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-600">
    <span>{{ label ?? 'Fréquentation prévue :' }}</span>
    <span
      v-for="entry in FREQUENTATION_LEVELS"
      :key="entry.level"
      class="flex items-center gap-1.5"
    >
      <span class="size-2.5 rounded-sm" :style="{backgroundColor: entry.color}" />
      {{ entry.label }}
    </span>
    <slot />
  </div>
</template>
